import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { useGlobalStore } from "~/stores/store-provider";
import { Connection } from "~/stores/slices/database";
import EditPostgreSQLConnection from "~/components/connections/edit/edit-postgresql-connection";
import EditMySQLConnection from "~/components/connections/edit/edit-mysql-connection";

const EditConnection = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { connectionsList, getConnectionDetails } = useGlobalStore(
    (state) => state
  );
  const [connection, setConnection] = useState<Connection | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Find the connection from the list
    const foundConnection = connectionsList.find((c: Connection) => c._id === id);
    if (foundConnection) {
      setConnection(foundConnection);
      getConnectionDetails(foundConnection).finally(() => {
        setIsLoading(false);
      });
    } else {
      // If not found, redirect to connections list
      navigate("/connections");
    }
  }, [id, connectionsList, getConnectionDetails, navigate]);

  if (isLoading) {
    return (
      <div className="container mx-auto p-6 max-w-4xl">
        <div className="flex justify-center items-center h-64">
          <span className="loading loading-spinner loading-lg"></span>
        </div>
      </div>
    );
  }

  if (!connection) {
    return (
      <div className="container mx-auto p-6 max-w-4xl">
        <div className="alert alert-error">
          <span>Connection not found</span>
        </div>
      </div>
    );
  }

  // Shopify and Metabase connections cannot be edited - redirect back
  if (
    connection.connection_type.toLowerCase() === "shopify" ||
    connection.connection_type.toLowerCase() === "metabase"
  ) {
    navigate("/connections");
    return null;
  }

  // Render the appropriate edit component based on connection type
  switch (connection.connection_type.toLowerCase()) {
    case "postgresql":
      return <EditPostgreSQLConnection connection={connection} />;
    case "mysql":
      return <EditMySQLConnection connection={connection} />;
    default:
      return (
        <div className="container mx-auto p-6 max-w-4xl">
          <div className="alert alert-warning">
            <span>
              Edit not supported for {connection.connection_type} connections
            </span>
          </div>
        </div>
      );
  }
};

export default EditConnection;
